import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SubscribeIcon } from '../../../../assets/icons/subscriptions/subscribe.svg';
import AppButton from '../app-button/AppButton';
import { mergeSubscriptionButtonSx } from './subscriptionIconOnlyButtonSx';

type AppButtonProps = React.ComponentProps<typeof AppButton>;

export type IRequestSubscriptionButtonProps = Omit<
  AppButtonProps,
  'children' | 'variant' | 'icon' | 'startIcon'
> & {
  iconOnly?: boolean;
};

/** Same API as subscribe; label is “request subscription” (private profiles). */
export function RequestSubscriptionButton(
  props: IRequestSubscriptionButtonProps,
) {
  const { loading, iconOnly, sx, ...rest } = props;
  const { t } = useTranslation();
  const label = t('common.requestSubscription');

  return (
    <AppButton
      {...rest}
      sx={mergeSubscriptionButtonSx(iconOnly, sx)}
      loading={loading}
      variant="contained"
      icon={<SubscribeIcon />}
      aria-label={iconOnly ? label : undefined}>
      {iconOnly ? null : label}
    </AppButton>
  );
}
